import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import pt from './translations/pt.json';
import en from './translations/en.json';
import fr from './translations/fr.json';

const SUPPORTED = ['pt', 'en', 'fr'];

const detectInitialLanguage = () => {
  try {
    // Visitante que já escolheu: respeitar a escolha guardada
    const saved = localStorage.getItem('language');
    if (saved && SUPPORTED.includes(saved)) return saved;
  } catch (_e) { /* noop */ }
  // Novo visitante: sempre português, independentemente do browser
  return 'pt';
};

const initialLng = detectInitialLanguage();

i18n
  .use(initReactI18next)
  .init({
    resources: {
      pt: { translation: pt },
      en: { translation: en },
      fr: { translation: fr }
    },
    lng: initialLng,
    fallbackLng: 'pt',
    supportedLngs: SUPPORTED,
    interpolation: { escapeValue: false },
    react: { useSuspense: false }
  });

// Keep <html lang="..."> in sync with current language (initial + on change)
const syncHtmlLang = (lng) => {
  try {
    if (typeof document !== 'undefined' && document.documentElement) {
      document.documentElement.setAttribute('lang', lng || 'pt');
    }
  } catch (_e) { /* noop */ }
};

syncHtmlLang(initialLng);
i18n.on('languageChanged', (lng) => {
  syncHtmlLang(lng);
  try { localStorage.setItem('language', lng); } catch (_e) { /* noop */ }
});

export default i18n;
